import { useMatchMobile } from '@avensia/excite';
import { createFlipYDecorator, SlideHeightAnimation } from '@avensia/excite-ui';
import { styled } from '@glitz/react';
import * as React from 'react';
import { useState } from 'react';
import { Button } from 'webapp/components/button';
import { ArrowUp } from 'webapp/components/icons';
import Link from 'webapp/components/Link';
import { isSvenssons, Theme } from 'webapp/theme';
import { createMaxMobileViewportDecorator, createMinMediumViewportDecorator } from 'webapp/viewport';

export function LinkCollection(props: NordicNest.Api.LinkCollectionBlockApiModel) {
  const isMobile = useMatchMobile();
  const [collapsed, setCollapsed] = useState(false);

  const links = (
    <Links>
      {Object.keys(props.links).map((key, i) => (
        <PageLink key={i} to={props.links[key]}>
          {key}
        </PageLink>
      ))}
    </Links>
  );

  return (
    <div>
      {isMobile ? (
        <CollapsibleHeader
          as={Theme.Transparent}
          disableRippleEffect
          onClick={() => {
            setCollapsed(!collapsed);
          }}
        >
          {props.title}
          {Object.keys(props.links).length > 0 && <ArrowUp css={createFlipYDecorator(collapsed)} />}
        </CollapsibleHeader>
      ) : (
        <DesktopHeader>{props.title}</DesktopHeader>
      )}
      {isMobile ? (
        <SlideHeightAnimation keepElement visible={collapsed}>
          {links}
        </SlideHeightAnimation>
      ) : (
        links
      )}
    </div>
  );
}

const PageLink = styled(
  Link,
  createMinMediumViewportDecorator({
    fontSize: t => t.footer?.fontSize,
  }),
  {
    fontSize: t => t.fontSize.xs,
    padding: { y: t => t.sharedSpacing.xs },
    display: 'block',
    ':hover': {
      textDecoration: 'underline',
    },
  },
);

const Links = styled.div(
  createMaxMobileViewportDecorator({
    padding: { x: t => t.sharedSpacing.xxl, bottom: t => t.sharedSpacing.l },
  }),
);

const DesktopHeader = styled.h3(
  createMaxMobileViewportDecorator({
    padding: { x: t => t.sharedSpacing.m },
  }),
  {
    fontSize: t => t.footer?.heading?.fontSize,
    fontWeight: t => t.footer?.heading?.fontWeight,
    textTransform: t => t.heading?.textTransform,
  },
  !isSvenssons && {
    margin: { bottom: t => t.sharedSpacing.m },
  },
);

const CollapsibleHeader = styled(Button, {
  display: 'flex',
  width: '100%',
  fontWeight: t => t.footer?.heading?.fontWeight,
  justifyContent: 'space-between',
  cursor: 'pointer',
  fontSize: t => t.fontSize.s,
  padding: { xy: t => t.sharedSpacing.l },
  border: { top: { color: t => t.footer?.accordion?.borderColor, style: 'solid', width: 'thin' } },
});
